var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 97,
    viewBox: "0 0 76 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1728 3V3C45.5917 3 47.9115 3.96134 49.6214 5.67235L70.5667 26.6315C72.0333 28.0992 72.8572 30.0892 72.8572 32.1641V32.1641M43.1728 3H13.3684C8.06924 3 3.77344 7.29582 3.77344 12.595V83.5978C3.77344 88.8969 8.06925 93.1927 13.3684 93.1927H63.2623C68.5614 93.1927 72.8572 88.8969 72.8572 83.5978V32.1641M43.1728 3V22.5691C43.1728 27.8683 47.4686 32.1641 52.7678 32.1641H72.8572",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0748 72.0839V56.7319H47.9128C48.9307 56.7319 49.9069 57.1363 50.6267 57.8561C51.3464 58.5758 51.7508 59.552 51.7508 60.5699C51.7508 61.5878 51.3464 62.564 50.6267 63.2838C49.9069 64.0036 48.9307 64.4079 47.9128 64.4079H44.0748M36.3988 56.7319V72.0839M21.0469 56.7319H28.7229L21.0469 72.0839H28.7229",
    stroke: "#292D32",
    strokeWidth: 3.83799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/zip-icon.8579ab22f1244b76f9022a05f4bb0ee8.svg";
export { ForwardRef as ReactComponent };